module.exports = __webpack_public_path__ + "img/dunkin_donut_logo.49330d44.jpg";